import {createLatestRequestRunner} from './requestRefreshScheduler'

export const createTopSectionCountsCoordinator = () => {
    const latestRequest = createLatestRequestRunner()

    return {
        refresh({countsRequest, entityTypesRequest, apply, onError}) {
            return latestRequest.run(
                () => Promise.all([countsRequest(), entityTypesRequest()]),
                {
                    applyResult: ([countsResponse, entityTypesResponse]) => apply({
                        counts: countsResponse.data.type.buckets,
                        entityTypes: entityTypesResponse?.data,
                    }),
                    onError,
                    rejectOnError: true,
                },
            )
        },

        invalidate(clear) {
            latestRequest.invalidate(clear)
        },
    }
}

export const refreshTopSectionCountsForEvent = ({event, isOpen, refresh, clear}) => {
    const scopes = event.detail?.scopes || []
    if (!scopes.includes('assets') && !scopes.includes('aggregations')) return

    if (!isOpen) {
        clear()
        return
    }

    const pendingRefresh = refresh()
    event.detail?.waitUntil?.(pendingRefresh)
    return pendingRefresh
}
